//import store from "../../store/index";
// import { connect } from "react-redux";

import Foundation from "./Foundation";

// const mapStateToProps = state => {
//   return { texts: state.texts };
// };
//
// export default connect(mapStateToProps)(Foundation);
export default Foundation;



// WEBPACK FOOTER //
// ./src/components/Foundation/index.js